import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { BlockUI, BlockUIService, NgBlockUI } from 'ng-block-ui';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import { loginData } from './models/loginData.model';
import { FocusMeDirective } from '../core/focus-me/focus-me.directive';
import { ConfirmService } from '../core/services/confirm.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-login-root',
  templateUrl: './login-root.component.html',
  styleUrls: []
})
export class LoginRootComponent implements OnInit, OnDestroy {

  @ViewChild(NgForm) loginForm!: NgForm;
  @ViewChild(NgForm) resetForm!: NgForm;

  doneLoading: boolean = false;
  login: loginData = new loginData();
  submitAttempt: boolean = false;
  pageMode: string = 'login';

  constructor(@Inject(DOCUMENT) private document: Document,
    private ajax: ajaxCall,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private notifier: NotifierService) {
    this.document.body.classList.add('login');
  }

  ngOnDestroy(): void {
    this.document.body.classList.remove('login');
  }

  ngOnInit(): void {
    this.doneLoading = true;
  }

  doLogin(): void {
    this.submitAttempt = true;
    if (this.loginForm.invalid) {
      return;
    }

    this.ajax.MakeCall<void>('/Login/CheckLogin', this.login).then(() => {
      if (this.route.snapshot.queryParams.returnUrl) {
        window.location.href = this.route.snapshot.queryParams.returnUrl;
      } else {
        this.router.navigateByUrl('/');
      }
    }, (data: any) => {
      this.notifier.notify('error', 'The user name and password combination that you provided is invalid.');
    });

  }

  doReset(): void {
    this.submitAttempt = true;
    if (this.resetForm.invalid) {
      return;
    }
    this.ajax.MakeCall<void>('/Login/ResetPassword', this.login).then(() => {
      this.notifier.notify('success', 'Thank you. We will check our database and send you a link to reset your password.');
      this.switchMode('login');
      this.login = new loginData();
    }, () => { });
  }

  switchMode(m: string): void {
    this.submitAttempt = false;
    this.pageMode = m;
  }
}
